import { ChatContext } from '../../../../coaching-base/chat-context.model';
import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../teamschat-dialog.action';
import { defaultState, TeamschatDialogState } from '../teamschat-dialog.state';
import { setFocus } from '../teamschat-transcript-dialog/function/set-focus.function';

import { Load, LoadResult } from './load.action';

export function loadReducer(
    _state: TeamschatDialogState,
    _action: PayloadAction<ActionType, Load>,
): TeamschatDialogState {
    const nextState = defaultState();

    nextState.hasPendingData = true;

    return nextState;
}

export function loadResultReducer(
    state: TeamschatDialogState,
    action: PayloadAction<ActionType, LoadResult>,
): TeamschatDialogState {
    let ctx: ChatContext | null;
    try {
        ctx = JSON.parse(action.payload.opts.context);
    } catch {}

    const focusTag = setFocus(
        ctx?.behaviourId,
        ctx?.subBehaviourId,
        action.payload.behaviours,
        action.payload.subBehaviours,
    );

    return {
        ...state,
        commitmentChat: action.payload.commitmentChat,
        behaviour: focusTag?.behaviour?.name ?? '',
        subBehaviour: focusTag?.subBehaviour?.name ?? '',
    };
}
